export function getRedirectTo() {
  return !window.location.pathname.includes('/login')
    ? `/login?redirectTo=${window.location.pathname}`
    : '/login';
}
